<template>
    <div class="container mescroll-touch">
        <div class="topdh" @click="back"><img src="../../assets/images/bjback.png" class="homeimg" />首页&nbsp;>&nbsp;会议导航
        </div>
        <img src="../../assets/images/bjtitle2.png" class="img" />
        <img src="../../assets/images/daohangimg.png" class="mainimg" alt="" />
        <div class="textrow bold">“北京励骏酒店”</div>
        <div class="textrow"><span class="bold">酒店地址</span>北京市东城区金宝街92号<br />(灯市口地铁站C东南口步行400米)</div>
        <img src="../../assets/images/bjfooter.png" class="footerimg" />
    </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
export default {
    name: 'bjdaohang',
    data() {
        return {
            imgurl: '',
        }
    },
    mixins: [mixin],
    created() {
        this.initbjShare();
        this.getinfo()
        document.title = "第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会";
    },
    methods: {
        getinfo() {
            let that = this;
            this.$axios.post('/api/api/web/activity/GetBJConfig?code=HYDH').then(res => {
                if (res.RetCode == "10000") {
                    // console.log(res.Data.Url)
                    that.imgurl = res.Data.Url
                }
            });
        },
        back() {
            this.$router.replace({ name: 'BJZL' })
        }
    }
}
</script>

<style lang="scss" scoped>
body {
    -webkit-overflow-scrolling: unset
}

.container {
    height: 100%;
    width: 100%;
    position: relative;
    -webkit-overflow-scrolling: unset // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.guanggaoimg {
    display: block;
    width: 90%;
    margin: 0.5rem auto;
}

.footerimg {
    display: block;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;
}

.topdh {
    font-family: cursive;
    font-weight: bold;
    background-image: linear-gradient(to right, #01B671, #2D5EAA);
    color: #fff;
    padding: 0.3rem;
}

.homeimg {
    width: 5%;
    display: inline-block;
    vertical-align: text-bottom;
    margin-right: 0.1rem;
}

.mainimg {
    width: 95%;
    position: relative;
    display: block;
    z-index: 100;
    margin: 0.5rem auto;
}

.textrow {
    background-image: linear-gradient(to right, #1DA3BA, #2D5EAA);
    width: 85%;
    margin: auto;
    margin-bottom: 0.3rem;
    text-align: center;
    color: #fff;
    padding: 0.2rem 0;
    border-radius: 7px;
}

.bold {
    font-weight: bold;
    display: block;
    font-size: .45rem;
    margin-bottom: 0.3rem;
}
</style>